/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import utils from '../../../../common/utils';
import { getErrorMessage, handleGraphServiceHttpError, unwrapServiceData } from './graphServiceUtils';
import { buildRubricsListPath } from './rubricsApiPaths';

/** GET /rubrics?graphId= */
export default class ListGraphEvaluationsService extends BaseService {
  constructor() {
    super(constants.GET_GRAPH_EVALUATIONS, 'listGraphEvaluationsStatus');
  }

  async handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { graphId } = payload;
    const url = buildRubricsListPath(graphId);

    const { isStackB } = utils.getStackBParams();

    if (isStackB) {
      const enhancedHeaders = await utils.resolveStackBHeaders(headers);
      return this.getClient('aiadminstackb').get(url, { headers: enhancedHeaders });
    }
    return this.getClient('aiadmin').get(url, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data && data.success) {
      const body = unwrapServiceData(response) ?? data;
      let evaluations = [];
      if (Array.isArray(body?.evaluations)) {
        evaluations = body.evaluations;
      } else if (Array.isArray(body?.items)) {
        evaluations = body.items;
      }
      const availableEvalTypes = Array.isArray(body?.availableEvalTypes) ? body.availableEvalTypes : [];
      Framework.getEventManager().publish(constants.GET_GRAPH_EVALUATIONS_SUCCESS, {
        data,
        evaluations,
        availableEvalTypes
      });
      return;
    }

    const msg = getErrorMessage(data, 'Unknown error');
    Framework.getEventManager().publish(constants.GET_GRAPH_EVALUATIONS_ERROR, { data, message: msg });
  }

  handleError(error) {
    handleGraphServiceHttpError(error, {
      fallbackLangMessage: 'graphEvaluation.FETCH_LIST_RETRY',
      errorEvent: constants.GET_GRAPH_EVALUATIONS_ERROR,
      updateGraphModelError: false
    });
  }
}
